import { Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import styles from 'features/DefaultHelp.module.css';

const ControlsSection = () => {
    return (
        <div>
            <Typography variant="h4">CONTROLS</Typography>
            <Table className={styles['controls-table']}>
                <TableHead>
                    <TableRow>
                        <TableCell>Actions</TableCell>
                        <TableCell>Description</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    <TableRow>
                        <TableCell>
                            <span>Search Bar</span>
                        </TableCell>
                        <TableCell>Search tickets by keywords or ticket numbers.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Filter Panel</span>
                        </TableCell>
                        <TableCell>Toggle ticket status filters (Open, On Hold, Closed, Escalated).</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Add New</span>
                        </TableCell>
                        <TableCell>Create a new support ticket by providing a subject and description.</TableCell>
                    </TableRow>

                    <TableRow>
                        <TableCell>
                            <span>Refresh</span>
                        </TableCell>
                        <TableCell>Reload the ticket list to see the most up-to-date status and comments.</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>
    );
};

export default ControlsSection;
